import React from 'react'

import { styled } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'

import { FormTitle } from 'components'

const StyledFormTitle = styled(FormTitle)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}))

const FormBlock = ({
  title,
  description,
  children,
  validationSchema,
  ...props
}) => {
  return (
    <Box my={1} {...props}>
      <StyledFormTitle title={title} description={description} />
      <div>{children}</div>
    </Box>
  )
}

export default FormBlock
